import React, { useState } from 'react';
import VolunteerForm from "./mentor";
import "../Donate/Donate.css";

const GetInvolvedPage = () => {
  const [selectedAction, setSelectedAction] = useState(null);

  const actions = [
    { id: 1, imageSrc: 'https://pratibhaposhak.in/images/mentorship.jpg', title: 'Sponsor for a child' },
    { id: 2, imageSrc: 'https://static.wixstatic.com/media/39c521_b9fb72290eac4e9381515cb0aff1a136~mv2.png/v1/fill/w_390,h_270,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/School%20Kit%20Logo.png', title: 'Sponsor a school kit' },
    { id: 3, imageSrc: '../Assests/books.png', title: 'Sponser Books and Study Materials' },
    { id: 4, imageSrc: '../Assests/Give_money.png', title: 'Way to Give ( Money )' },
  ];

  const handleActionClick = (id) => {
    setSelectedAction(id);
  };

  const handleCancel = () => {
    setSelectedAction(null);
  };

  return (
    <div className="get-involved-container">
      {/* Header Section */}
      <div className="header-section">
        <h1>Get Involved with Us</h1>
        <p>
          Together we can see our grand vision come true – a world where every bright student,
          even from abject poverty and from the remotest village, has access to the best quality
          education and caring mentorship that helps in realizing his/her full potential and
          becoming a contributor to society.
        </p>
      </div>

      {/* Action Grid Section */}
      {selectedAction === null ? (
        <div className="action-grid">
          {actions.map((action) => (
            <div
              key={action.id}
              className="action-item"
              onClick={() => handleActionClick(action.id)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={action.imageSrc}
                alt={action.title}
                className="action-image"
                style={{
                  width: action.id === 2 || action.id === 4 ? '57%' : '40%',
                  height: 'auto',
                }}
              />
              <h3>{action.title}</h3>
            </div>
          ))}
        </div>
      ) : (
        <VolunteerForm selectedAction={selectedAction} onCancel={handleCancel} />
      )}
    </div>
  );
};

export default GetInvolvedPage;
